import React from 'react';
import './Spinner.scss';

function Spinner(_props) {
    return (
        <div className="spiner">
            <div className="spin"></div>
        </div>
    );
}

export default Spinner;
